import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Slide from '@mui/material/Slide';

const SnackbarComponent = ({ open, onClose, severity, message, position }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={3000} // Auto hide duration
      onClose={onClose} // Close event handler
      anchorOrigin={position || { vertical: 'top', horizontal: 'center' }} // Default position
      TransitionComponent={Slide} // Slide animation
    >
      <MuiAlert
        onClose={onClose}
        severity={severity || 'info'} // Default severity to 'info'
        sx={{ width: '100%' }}
      >
        {message || 'Default message'} {/* Default message */}
      </MuiAlert>
    </Snackbar>
  );
};

export default SnackbarComponent;
